import { useCallback, useEffect, useState } from 'react';
import { useApi } from '../context/ApiProvider';
import { useAlertContext } from '../context/AlertProvider';
import { CustomAlertDialogInterface } from '../shared/type/CustomAlertDialog.type';
import { AxiosResponse } from 'axios';
import { OrderDtoInterface } from '../shared/type/order.type';

export const useOrderDetailsData = (orderId: number) => {
  const { apiOrderController } = useApi();
  const [order, setOrder] = useState<OrderDtoInterface | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const { setAlertProperties, setShow: setShowAlert } = useAlertContext();

  const getAlertBody = (string: string): CustomAlertDialogInterface => ({
    status: 'error',
    title: 'Błąd',
    description: `Nie udało się anulować ${string}`,
    timeout: 9000
  });

  const fetchOrderData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response: AxiosResponse<OrderDtoInterface> = await apiOrderController('order').get(
        `/${orderId}`
      );
      if (response.status === 200) {
        setOrder(response.data);
      }
    } catch (error: any) {
      setAlertProperties(getAlertBody(`Something went wrong during download details`));
      setShowAlert(true);
    } finally {
      setIsLoading(false);
    }
  }, [orderId]);

  useEffect(() => {
    if (orderId && orderId !== 0) {
      fetchOrderData();
    }
  }, [orderId]);

  return {
    order,
    isLoading
  };
};
